import LocaleSelect from 'components/global/LocaleSelect';

// TopBar uses the dark variant and disables the active locale option.
const TopBarLocaleSelect = props => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <LocaleSelect variant="dark" disableCurrentOption {...props} />
);

export default TopBarLocaleSelect;
